import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaWater } from "react-icons/fa";
import { PiMountains } from "react-icons/pi";
import { BsTree } from "react-icons/bs";
import { VscCompass } from "react-icons/vsc";
import ForgeLogo from "../components/logo";
import "./DonateHero.css";

/* Headline — line 1 forest, line 2 rust (matches design) */
const HEADLINE = ["Support", "The Mission."];
const RAIL_ICONS = [PiMountains, BsTree, FaWater, VscCompass];

const ease = [0.22, 1, 0.36, 1];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};
const lineUp = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.85, ease } },
};
const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease, delay } },
});

export default function DonateHero() {
  return (
    <section className="dnhero" id="donate-top">

      {/* Background photo */}
      <div className="dnhero__media" aria-hidden="true">
        <motion.img
          src="./assets/hero.png"
          alt=""
          className="dnhero__img"
          initial={{ scale: 1.06, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.8, ease }}
        />
        <div className="dnhero__scrim" />
      </div>

      {/* Cloud layer */}
      <div className="clouds" aria-hidden="true">
        <img src="./assets/image.png" alt="" />
        <img src="./assets/image.png" alt="" className="cloud-flip" />
      </div>

      <Container fluid="xl" className="dnhero__inner container-fg container-2xxl">

        {/* Rail */}
        <motion.aside
          className="hero__rail dnhero__rail"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5, ease }}
          aria-hidden="true"
        >
          <span className="hero__rail-num">01</span>
          <span className="hero__rail-line" />
          <ul className="hero__rail-icons">
            {RAIL_ICONS.map((Icon, i) => (
              <li key={i}>
                <Icon />
                <span className={`hero__rail-line ${i === RAIL_ICONS.length - 1 ? "" : "alt"}`} />
              </li>
            ))}
          </ul>
        </motion.aside>

        {/* Content */}
        <div className="dnhero__content">

          {/* Headline — two-tone */}
          <motion.h1
            className="dnhero__title u-display"
            variants={container}
            initial="hidden"
            animate="show"
          >
            {HEADLINE.map((line, i) => (
              <span className="hero__line" key={i}>
                <motion.span
                  className="hero__line-inner"
                  variants={lineUp}
                  style={{ color: i === 1 ? "var(--accent)" : "var(--c-forest)" }}
                >
                  {line}
                </motion.span>
              </span>
            ))}
          </motion.h1>

          {/* Rust rule + forge mark row */}
          <motion.div
            className="dnhero__rule-row"
            variants={fadeUp(0.52)}
            initial="hidden"
            animate="show"
            aria-hidden="true"
          >
            <span className="dnhero__rule" />
            <ForgeLogo fill="var(--c-rust)" width={22} height={22} />
          </motion.div>

          {/* Body copy */}
          <motion.p
            className="dnhero__sub"
            variants={fadeUp(0.62)}
            initial="hidden"
            animate="show"
          >
            Your support helps us provide life-changing retreats for veterans,
            first responders, and gold star families—at no cost to them.
          </motion.p>
        </div>
      </Container>
    </section>
  );
}
